export enum ProductType {
  Platform = "Platform",
  ManagedInvestment = "ManagedInvestment",
  IndustryFund = "IndustryFund",
  Other = "Other",
}
